import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Layout from "../../../components/layout";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import {
  ReporteContactCenterDispatcher,
  reporteContactCenterDispatcher
} from "./ReporteContactCenter.dispatcher";
import {
  ReporteContactCenterStore,
  reporteContactCenterStore
} from "./ReporteContactCenter.store";
import ReporteContactCenterComponent from "../../../components/comisionesContactCenter/reporte";

interface Props
  extends ReporteContactCenterStore,
    ReporteContactCenterDispatcher {}

@ReduxConnect(reporteContactCenterStore, reporteContactCenterDispatcher)
export default class ReporteContactCenterContainer extends Component<Props> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Reporte de Comisiones - Contact Center" />
          <ReporteContactCenterComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
